import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import AdminLogin from "@/pages/AdminLogin";
import Generator from "@/pages/Generator";
import History from "@/pages/History";
import PromptDetail from "@/pages/PromptDetail";
import Settings from "@/pages/Settings";
import AdminPanel from "@/pages/AdminPanel";
import AdminDashboard from "@/pages/AdminDashboard";
import Pricing from "@/pages/Pricing";
import PaymentResult from "@/pages/PaymentResult";
import Transactions from "@/pages/Transactions";
import { ParticipantRoute, AdminRoute } from "@/components/ProtectedRoute";

import "@/App.css";

export default function App() {
  return (
    <div className="App min-h-screen bg-[#0A0A0A] text-white">
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/login" element={<Login />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/payment/result" element={<PaymentResult />} />

          {/* Participant */}
          <Route element={<ParticipantRoute />}>
            <Route path="/" element={<Navigate to="/generator" replace />} />
            <Route path="/generator" element={<Generator />} />
            <Route path="/history" element={<History />} />
            <Route path="/prompts/:id" element={<PromptDetail />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/transactions" element={<Transactions />} />
          </Route>

          {/* Admin */}
          <Route element={<AdminRoute />}>
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/whitelist" element={<AdminPanel />} />
          </Route>

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}
